import schema from '../form-configs/schema';
import data from '../form-configs/data';
import { customerInfoLayout, deliveryInfoLayout } from '../form-configs/layout';

export const issueReplacementInvoice = context => ({
  schema: {
    ...schema(context),
  },
  formModel: {
    ...data,
  },
  layout: {
    ...customerInfoLayout,
    'div.grid.grid-cols-1:0': {
      div: {
        slot: 'invoice-info-title',
      },
      'div.grid.grid-cols-2.gap-x-30': {
        'div.col-span-1.md-col-span-2': { field: 'invoice_type' },
        'div.col-span-1.md-col-span-2:0': { field: 'template_code' },
        'div.col-span-1.md-col-span-2:1': { field: 'invoice_common_code' },
        'div.col-span-1.md-col-span-2:2': { field: 'date_created' },
        'div.col-span-1.md-col-span-2:3': { field: 'payment_method' },
        'div.col-span-1.md-col-span-2:4': { field: 'currency_code' },
        'div.col-span-1.md-col-span-2:5': { field: 'foreign_rate' },
      },
    },
    ...deliveryInfoLayout,
    'div.grid.grid-cols-1:2': {
      div: {
        slot: 'additional-info-title',
      },
      'div.grid.grid-cols-2.gap-x-30': {
        'div.col-span-1.md-col-span-2': { field: 'invoice_number' },
        'div.col-span-1.md-col-span-2:0': { field: 'agreement_date' },
        'div.col-span-1.md-col-span-2:1': { field: 'reason_change' },
        'div.col-span-1.md-col-span-2:2': { field: 'evidence_for_change' },
        'div.col-span-1.md-col-span-2:3': { field: 'note_change' },
      },
      'div:0': {
        slot: 'additional-info-note',
      },
    },
  },
});

export default issueReplacementInvoice;



// WEBPACK FOOTER //
// ./src/portal-components/invoice/actions-invoice/form-definition/issue-replacement-invoice.js